






import { Component, Vue } from 'vue-property-decorator';
import MessageSearch from "../components/MessageSearch.vue"; // @ is an alias to /src
import LayoutDefault from '../../layout/default.vue';
@Component({
  components: {
      MessageSearch,
  },
})
export default class Home extends Vue {
    created() {

        this.$emit('update:layout', LayoutDefault);

    }


}
